// src/components/common/StatusBadge.tsx

import React from 'react';

interface StatusBadgeProps {
    isActive: boolean;
    size?: 'sm' | 'md' | 'lg';
    showText?: boolean;
    className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
    isActive,
    size = 'sm',
    showText = true,
    className = '',
}) => {
    const sizeClasses = {
        sm: {
            dot: 'w-2 h-2',
            text: 'text-xs',
            gap: 'gap-1.5',
        },
        md: {
            dot: 'w-2.5 h-2.5',
            text: 'text-sm',
            gap: 'gap-2',
        },
        lg: {
            dot: 'w-3 h-3',
            text: 'text-base',
            gap: 'gap-2.5',
        },
    };

    const sizeConfig = sizeClasses[size];

    return (
        <div className={`flex items-center ${sizeConfig.gap} ${className}`}>
            <span
                className={`inline-block rounded-full ${sizeConfig.dot} ${
                    isActive ? 'bg-green-500' : 'bg-red-500'
                }`}
            />
            {showText && (
                <span
                    className={`font-medium ${sizeConfig.text} ${
                        isActive ? 'text-green-700' : 'text-red-700'
                    }`}
                >
                    {isActive ? 'Active' : 'Inactive'}
                </span>
            )}
        </div>
    );
};

export default StatusBadge;